import React, { Component } from 'react';
import "./Body.scss";
import { scrollDown } from '../Services/scrollAnimation';
import { Link, animateScroll as scroll } from "react-scroll";

import { GA_Push } from '../Services/GoogleAnalytics';

export default class Body extends Component {
    state = {}
    render() {
        return (
            <div>
                <section className="section-hero">
                    <div className="credit">
                        <div className="text">
                            אליאור לוי  ,
                            <a target="_blank" href="https://twitter.com/eliorlevy">
                                eliorlevy@
                            </a>
                        </div>
                        <a target="_blank" href="https://twitter.com/eliorlevy">
                            <div className="icon">
                            </div>
                        </a>
                    </div>
                    <Link activeClass="active"
                        to="section-content"
                        spy={true}
                        smooth={true}
                        hashSpy={true}
                        duration={1500}
                    >
                        <div className="arrow"> </div>
                    </Link>


                </section>


                <section id="section-content" className="section-content">
                    <div className="box">
                        <div className="image pic4" onClick={() => {
                            window.open("https://www.ynet.co.il/articles/0,7340,L-5476972,00.html", '_blank');
                            GA_Push('article_clicked', 'https://www.ynet.co.il/articles/0,7340,L-5476972,00.html');
                        }}>
                            <div className="link">
                                <div className="text">
                                    המחאה על הגבול - הסיפור המלא
                                    <div className="icon-video">
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                    <div className="box">
                        <div className="image pic2" onClick={() => {
                            window.open("https://www.ynet.co.il/articles/0,7340,L-5476974,00.html", '_blank');
                            GA_Push('article_clicked', 'https://www.ynet.co.il/articles/0,7340,L-5476974,00.html');
                        }}>
                            <div className="link">
                                <div className="text">
                                    הפוסט בפייסבוק שהבעיר את הגדרות
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="box">
                        <div className="image pic6" onClick={() => {
                            window.open("https://www.ynet.co.il/articles/0,7340,L-5478072,00.html", '_blank');
                            GA_Push('article_clicked', 'https://www.ynet.co.il/articles/0,7340,L-5478072,00.html');
                        }}>
                            <div className="link">
                                <div className="text">
                                    זעקת העוטף
                                </div>
                                <p className="reporter">
                                מתן צורי ורועי עידן
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="box">
                        <div className="image pic5" onClick={() => {
                            window.open("https://www.ynet.co.il/articles/0,7340,L-5478068,00.html", '_blank');
                            GA_Push('article_clicked', 'https://www.ynet.co.il/articles/0,7340,L-5478068,00.html');
                        }}>
                            <div className="link">
                                <div className="text">
                                    שומרי השגרה
                                </div>
                                <p className="reporter">
                                    יואב זיתון
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="box">
                        <div className="image pic1" onClick={() => {
                            window.open("https://www.ynet.co.il/articles/0,7340,L-5476973,00.html", '_blank');
                            GA_Push('article_clicked', 'https://www.ynet.co.il/articles/0,7340,L-5476973,00.html');
                        }}>
                            <div className="link">
                                <div className="text">
                                    7 השנים הרעות של חמאס
                                </div>
                                <div className="ynet-plus">
                                
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="box">
                        <div className="image pic3" onClick={() => {
                            window.open("https://www.ynet.co.il/articles/0,7340,L-5476971,00.html", '_blank');
                            GA_Push('article_clicked', 'https://www.ynet.co.il/articles/0,7340,L-5476971,00.html');
                        }}>
                            <div className="link">
                                <div className="text">
                                    "צעדות השיבה" במספרים
                                    <div className="icon-graph"></div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/Body/Body.jsx